import { Component, defineComponent, defineAsyncComponent } from 'vue';
import LoadingAnimation from '@/presentation/components/loading-animation/loading-animation.vue';
import AppComponent from '@/presentation/app-class';
import tableComponentLoader from '@/presenters/table-component-loader';

export default defineComponent({
	components: {
		TheBatchesOverview: defineAsyncComponent(tableComponentLoader.loadBatchesOverviewTable.bind(tableComponentLoader)),
		LoadingAnimation: LoadingAnimation as Component
	},
	setup: () => {
		const component = new AppComponent();

		return {
			loadingStarted: component.loadingStarted,
			loadingFinished: component.loadingFinished
		};
	}
});
